// extracted by css-extract-rspack-plugin
export default {"gridContainer":"_4d51bc6","visuallySimilarWrapper":"_d7527c6a","auctionBanner":"_9d4644c6"};